import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/product-management/")({
  loader: ({ location }) => {
    if (location.pathname === "/product-management") {
      throw redirect({
        to: "/product-management/inbox",
      })
    }
    return null
  },
})
